import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'

import LinkButton from 'core/components/link-button'

import { getBaseBillingUrl } from '../../../helpers/url-helper'

import Text from '@eig-builder/module-localization'
import { getUrl, siteNames } from '@eig-builder/core-utils/helpers/url-helper'

const StyledButton = styled(LinkButton)`
  margin-right: ${props => props.theme.spacing(2)}px !important;
`

const BottomRowButtons = ({ account }) => {
  const singlePlatformCustomer = account.accountType === 2
  const constantContactCustomer = account.accountType === 3

  const loginUrl = getUrl(siteNames.API_CRM, `/v1.0/account/login/${account.partnerId}/${account.id}`)

  return (
    <>
      <StyledButton
        color='secondary'
        disabled={account.partnerId >= 100}
        to={loginUrl}
        external
        dataElementSuffix='account-details-login'
      >
        <Text message='modules.crm.components.account.login' />
      </StyledButton>
      <StyledButton
        color='secondary'
        disabled={account.uberClientId === null || singlePlatformCustomer || constantContactCustomer}
        to={`${getBaseBillingUrl(account.partnerId)}/admin/clientmgr/client_profile.php?clientid=${
          account.uberClientId
        }`}
        external
        dataElementSuffix='account-details-billing-client'
      >
        <Text message='modules.crm.components.account.billingClient' />
      </StyledButton>
    </>
  )
}

BottomRowButtons.propTypes = {
  account: PropTypes.object.isRequired
}

export default BottomRowButtons
